import { useDispatch, useSelector } from 'react-redux';
import { Goals24 } from 'ui/icons/aurora/24px/studio';
import { selectDoesUserHaveRbacPermission } from 'core/userContext';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { SettingsTab } from 'modules/journey/components/SettingsTakeover/SettingsTakeover.constants';
import {
  JoureyConversionWrapper,
  JourneyContainer,
  JourneyConversionAdded,
  JourneyConversionTitle,
} from './AttachedJourneyConversion.styled';
import { TakeoverType } from '../takeovers';
import {
  openTakeover,
  closeTakeover,
  getOpenedNodeId,
  getJourneyCurrentConversionEventName,
} from '../../ducks';

export const ATTACHED_JOURNEY_CONVERSION_TEST_ID = 'attached-journey-conversion';
export const ATTACHED_JOURNEY_CONVERSION_EVENT = 'attached-journey-conversion-event';

export const AttachedJourneyConversion = () => {
  const currentConversion = useSelector(getJourneyCurrentConversionEventName);
  const dispatch = useDispatch();
  const canDraftMessaging = useSelector((state) =>
    selectDoesUserHaveRbacPermission(state as any)(PROJECT_PERMISSIONS.DraftMessaging),
  );
  const openedNodeId = useSelector(getOpenedNodeId);

  const handleAttachedJourney = () => {
    dispatch(
      openTakeover(TakeoverType.Settings, {
        focusedTab: SettingsTab.ConversionsAndMetrics,
        canDraftMessaging,
        isOverlay: !openedNodeId,
        onClose: () => dispatch(closeTakeover(TakeoverType.Settings)),
      }),
    );
  };

  return (
    <JourneyContainer>
      <JoureyConversionWrapper
        data-test={ATTACHED_JOURNEY_CONVERSION_TEST_ID}
        onClick={handleAttachedJourney}
      >
        <Goals24 />
        <div>
          <JourneyConversionTitle data-test={ATTACHED_JOURNEY_CONVERSION_EVENT}>
            {currentConversion}
          </JourneyConversionTitle>
          <JourneyConversionAdded>Journey conversion event</JourneyConversionAdded>
        </div>
      </JoureyConversionWrapper>
    </JourneyContainer>
  );
};
